import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";

import { Input } from 'semantic-ui-react';
import Parser from 'html-react-parser';

import OutsideHandler from 'components/common/OutsideHandler';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './CommonSearchDropdownSelector.css';


class CommonSearchDropdownSelector extends Component {
  static propTypes = {
    setSelectedItem: PropTypes.func.isRequired,
    itemsList: PropTypes.arrayOf(PropTypes.shape),
    searchPlaceholder: PropTypes.string,
  };

  static defaultProps = {
    itemsList: null,
    searchPlaceholder: null,
  };

  state = {
    selectedItem: null,
    activeSearh: false,
    searchValue: null,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedItem !== this.state.selectedItem) {
      this.setState({ activeSearh: false });
    }
  }

  handleClickOutside = () => {
    this.setState({ searchValue: null });
    setTimeout(() => {
      this.setState({ activeSearh: false });
    }, 200);
  };

  renderListItem = item => (
    <div
      className="item-wrapper"
      onClick={() => {
        this.setState({ selectedItem: this.props.itemsList
          .filter(listItem => listItem.id === item.id)[0]});
        this.props.setSelectedItem(
          this.props.itemsList
            .filter(listItem => listItem.id === item.id)[0]
        );
      }}
      role="button"
      tabIndex={-1}
    >
      {item.icon_svg &&
        <div className="icon">{Parser(item.icon_svg)}</div>
      }
      <div className="name">{item.name}</div>
      {item.isPro && <div className="pro-label">PRO</div>}
    </div>
  );

  render() {
    const { itemsList, searchPlaceholder } = this.props;
    const { searchValue, activeSearh, selectedItem } = this.state;

    if (!itemsList) return null;

    return (
      <div className="common-search-dropdown-selector__component">
        <OutsideHandler handleClickOutside={this.handleClickOutside}>
          <Fragment>
            <div
              className="current-value"
              onClick={() => this.setState({ activeSearh: true }) }
              role="button"
              tabIndex={-1}
            >
              <div className="content">
                {(selectedItem && this.renderListItem(selectedItem))
                  || (searchPlaceholder || 'Select Item')}
              </div>
              <div className="arrow" />
            </div>

            {activeSearh &&
              <div className="dropdown-wrapper">
                <div className="input-wrapper">
                  <Input
                    icon="search"
                    placeholder="Start typing or select..."
                    onChange={e => this.setState({ searchValue: e.target.value }) }
                  />
                </div>
                <div className="dropdown-block">
                  {itemsList
                    .filter(item => !searchValue ? item
                      : item.name.toLowerCase().includes(searchValue.toLowerCase()))
                    .map(item => (
                      <ProFeaturePlaceholder
                        noKeyIcon
                        locked={item.isLocked}
                        placeholderContent={
                          <div>
                            {item.proPlaceholder}&nbsp;on the <strong>PRO</strong> plan.
                          </div>
                        }
                      >
                        {this.renderListItem(item)}
                      </ProFeaturePlaceholder>
                    ))}
                </div>
              </div>
            }
          </Fragment>
        </OutsideHandler>
      </div>
    );
  }
}

export default CommonSearchDropdownSelector;
